<template>
  <Card class="h-full" :pt="{
					body: {
						style: { 'overflow-y': 'hidden' }
					},
					content: {
						style: {
							'overflow-y': 'scroll',
							'border-top': 'solid 1px rgb(203,213,225)',
							'margin-top': '0.75rem',
							'margin-bottom': '-1rem',
						}
					}
				}">
    <template #title>{{ $t('widgets.lists.devices_being_updated_list.device_updates') }}</template>
    <template #content>
      <List class="flex-1 overflow-scroll -mx-4 px-4 sm:-mx-6 sm:px-6 h-full -mt-6">
        <DevicesBeingUpdatedListItem
            v-for="log in deviceDownloadLogs?.data"
            :log="log"
            @on-show="showDeviceDownloadLog"
            :show-device-type="showDeviceType"
            :show-device-model="showDeviceModel"
            :show-device-revision="showDeviceRevision"
            :show-serial-number="showSerialNumber"
            :show-initiated-at="showInitiatedAt"
            :show-initiated-by="showInitiatedBy"
        />
      </List>
    </template>
  </Card>

  <DeviceDownloadLogSlideOver ref="slideOver"/>
</template>

<script>
import List from "@/Components/List.vue";
import {IconCloudDownload, IconEye} from "@tabler/icons-vue";
import {mapStores} from "pinia";
import {useDeviceDownloadLogsStore} from "@/stores/deviceDownloadLogs.js";
import DevicesBeingUpdatedListItem from "@/Widgets/Lists/DevicesBeingUpdatedListItem.vue";
import DeviceDownloadLogSlideOver from "@/Slideovers/DeviceDownloadLogSlideOver.vue";

export default {
  name: "DevicesBeingUpdatedList",
  data() {
    return {
      params: {
        include: [
          'currentFirmware',
          'targetFirmware',
        ],
        sort: '-initiated_at'
      },
      deviceDownloadLogs: undefined,
    }
  },
  props: {
    device: {
      type: Number,
    },
    showDeviceType: {
      type: Boolean,
      default: false,
    },
    showDeviceModel: {
      type: Boolean,
      default: false,
    },
    showDeviceRevision: {
      type: Boolean,
      default: false,
    },
    showSerialNumber: {
      type: Boolean,
      default: false,
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapStores(useDeviceDownloadLogsStore),
  },
  methods: {
    IconCloudDownload,
    async refreshDeviceDownloadLogs() {
      let params = this.params;

      if (this.showDeviceType)
        params.include.push('device.deviceType');

      if (this.showDeviceModel)
        params.include.push('device.deviceModel');

      if (this.showDeviceRevision)
        params.include.push('device.deviceRevision');

      if (this.showInitiatedBy)
        params.include.push('initiatedBy');

      params.filter = this.device ? {device_id: this.device} : undefined;
      this.deviceDownloadLogs = await this.deviceDownloadLogsStore.indexDeviceDownloadLogs(params);
    },
    showDeviceDownloadLog(log) {
      this.$refs.slideOver.showDeviceDownloadLog(log);
    }
  },
  components: {
    DeviceDownloadLogSlideOver,
    DevicesBeingUpdatedListItem,
    IconEye,
    List,
  },
  async mounted() {
    await this.refreshDeviceDownloadLogs()
  }
}
</script>

<style scoped>

</style>